// extracted by mini-css-extract-plugin
export default {"exerciseHeader":"exercise-view_exerciseHeader__znIlP","title":"exercise-view_title__P3lCH","exerciseText":"exercise-view_exerciseText__HtJX4"};